import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getPigletHerdDetails, getPigletHerdDetailsAdmin } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE_TIME, FOOTPRINTING_PIGLET_HERD_DETAILS } from "consts";

export const useGetFootprintingPigletHerdDetails = (primaryDataId: string, options?: { enabled?: boolean }) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQuery(
    {
      queryKey: [FOOTPRINTING_PIGLET_HERD_DETAILS, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getPigletHerdDetailsAdmin(primaryDataId) : getPigletHerdDetails(primaryDataId)),
      enabled: options?.enabled !== false && !!primaryDataId,
      gcTime: DEFAULT_CACHE_TIME,
      staleTime: DEFAULT_CACHE_TIME,
    },
    queryClient
  );
};
